<template>
    <div class="xeBlankWidget heightMAX">
        <div class="kbet-custom-reset heightMAX">
            <div
                class="kbet-widget-blank heightMAX"
                :style="getGlassTintStyle()"
                style="border-radius: 20px !important"
            >
                <!-- 빈 컨텐츠 영역 -->
                <!-- <div class="blank-content">
                    <div class="blank-placeholder">
                        <i class="fas fa-plus-circle"></i>
                        <span>{{ $t("빈 위젯") }}</span>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- 설정 모달 -->
        <b-modal
            ref="modalSetting"
            :title="`${$t('설정')} - ${$t('빈 위젯')}`"
            body-class="p-t-0 p-b-0"
            hide-footer
            @hidden="onModalCancel"
        >
            <blank-widget-setting
                :initSetting="blankWidgetSetting"
                @on-modal-cancel="onModalCancel"
                @on-modal-ok="onModalOK"
            />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "./common/xeBaseWidget.js";
import BlankWidgetSetting from "./setting/xeBlankWidgetSetting.vue";

export default {
    name: "xeBlankWidget",
    extends: xeBaseWidget,
    components: {
        BlankWidgetSetting,
    },
    props: {
        contextMenu: {
            type: Object,
            default: () => {},
        },
        width: {
            type: Number,
            default: 1,
        },
        height: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            themeColor: global.xe.parseBool(localStorage.contentInverse)
                ? require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").dark
                : require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").light,
        };
    },
    computed: {
        blankWidgetSetting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
    },
    async created() {
        if (!this.widget.moved) {
            this.widget.moved = false;
        }
        if (!this.widget.panel) {
            this.widget.panel = {
                backgroundColor: "#1a1a2e",
            };
        }
        if (!this.widget.title) {
            this.widget.title = "";
        }
    },
    methods: {
        getGlassTintStyle() {
            const c = this.widget?.panel?.backgroundColor;
            if (!c) return { "--glass-tint": "transparent" };

            if (typeof c === "string" && c.startsWith("#")) {
                const rgb = this.hexToRgb(c);
                if (rgb) return { "--glass-tint": `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.15)` };
            }

            return { "--glass-tint": c };
        },

        hexToRgb(hex) {
            const raw = String(hex || "")
                .replace("#", "")
                .trim();
            if (!raw) return null;

            const normalized =
                raw.length === 3
                    ? raw
                          .split("")
                          .map((ch) => ch + ch)
                          .join("")
                    : raw.length === 6
                      ? raw
                      : null;
            if (!normalized) return null;

            const num = parseInt(normalized, 16);
            if (Number.isNaN(num)) return null;
            return {
                r: (num >> 16) & 255,
                g: (num >> 8) & 255,
                b: num & 255,
            };
        },

        onModalCancel() {
            this.$refs.modalSetting.hide();
        },

        onModalOK(setting) {
            // 설정 모달에서 OK를 누르면 위젯정보가 변경된 것이므로, 해당위젯을 찾아서 실제정보를 저장한다.
            const updatedWidget = Object.assign({}, this.widget, setting);

            this.$refs.modalSetting.hide();

            // 설정이 변경되었음을 부모 컴포넌트에 알림
            this.$emit("on-change-widget", updatedWidget);
        },
    },
};
</script>

<style scoped>
.kbet-widget-blank {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    color: inherit;
}

.kbet-widget-blank::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background:
        radial-gradient(ellipse 130% 85% at 12% -8%, rgba(255, 255, 255, 0.88) 0%, transparent 52%),
        radial-gradient(ellipse 90% 70% at 108% 108%, rgba(165, 200, 255, 0.22) 0%, transparent 48%),
        linear-gradient(0deg, var(--glass-tint, transparent), var(--glass-tint, transparent)),
        linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.38) 0%,
            rgba(255, 255, 255, 0.07) 42%,
            rgba(255, 255, 255, 0.04) 58%,
            rgba(245, 250, 255, 0.28) 100%
        );
    border: 1px solid rgba(255, 255, 255, 0.92);
    box-shadow:
        0 0 0 1px rgba(255, 255, 255, 0.28) inset,
        0 1px 0 rgba(255, 255, 255, 0.98) inset,
        0 -1px 0 rgba(15, 23, 42, 0.06) inset,
        0 14px 40px rgba(15, 23, 42, 0.08),
        0 4px 14px rgba(15, 23, 42, 0.04);
    backdrop-filter: blur(32px) saturate(1.65);
    -webkit-backdrop-filter: blur(32px) saturate(1.65);
    pointer-events: none;
    z-index: 0;
}

.kbet-widget-blank > * {
    position: relative;
    z-index: 1;
}

.blank-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 20px;
}

.blank-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    transition: all 0.3s ease;
}

.blank-placeholder i {
    font-size: 48px;
    opacity: 0.5;
    transition: all 0.3s ease;
}

.blank-placeholder span {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.5px;
}

/* 호버 효과 */
.kbet-widget-blank:hover .blank-placeholder {
    color: rgba(255, 255, 255, 0.8);
}

.kbet-widget-blank:hover .blank-placeholder i {
    opacity: 0.8;
    transform: scale(1.1);
}

/* 반응형 스타일 */
@media (max-width: 768px) {
    .blank-placeholder i {
        font-size: 36px;
    }

    .blank-placeholder span {
        font-size: 14px;
    }
}

@media (max-width: 576px) {
    .blank-placeholder i {
        font-size: 28px;
    }

    .blank-placeholder span {
        font-size: 12px;
    }
}
</style>
